import { post } from "../Services/http"

export const SHOW_COMPLEMENTARY_PRODUCTS_DRAWER = "SHOW_COMPLEMENTARY_PRODUCTS_DRAWER"
export const SET_ADDED_PRODUCT = "SET_ADDED_PRODUCT"
export const SET_COMPLEMENTARY_PRODUCTS = "SET_COMPLEMENTARY_PRODUCTS"
export const CLOSE_COMPLEMENTARY_PRODUCTS_DRAWER = "CLOSE_COMPLEMENTARY_PRODUCTS_DRAWER"

export const getComplementaryProducts = (articleNumber, quantity) => (dispatch, getState) => {
    return post(`/api/cart/complementary-products`, { articleNumber, quantity })
        .then((response) => response.json())
        .then((data) => {
            if (data && data.products && data.products.length > 0) {
                dispatch(setComplementaryProducts(data.products))
                dispatch(setAddedProduct({ id: data.originalProductId, name: data.originalProductName }))
                dispatch(showComplementaryProductsDrawer())
            }
        })
}

export const showComplementaryProductsDrawer = () => ({
    type: SHOW_COMPLEMENTARY_PRODUCTS_DRAWER,
})

export const closeComplementaryProductsDrawer = () => ({
    type: CLOSE_COMPLEMENTARY_PRODUCTS_DRAWER,
})

const setAddedProduct = (product) => ({
    type: SET_ADDED_PRODUCT,
    payload: {
        addedProduct: product,
    },
})

const setComplementaryProducts = (products) => ({
    type: SET_COMPLEMENTARY_PRODUCTS,
    payload: {
        products: products,
    },
})
